import Cookies from 'js-cookie'

enum TAB {
  Details,
  Consent,
  About
}

declare global {
  interface Window {
    CookieConsent: {
      set: (name: string, value: string, days: number) => void
      get: (name: string) => string | undefined
      hasConsent: () => boolean
      remove: (name: string) => void
    }
  }
}

window.CookieConsent = {
  set: function (name: string, value: string, days: number) {
    Cookies.set(name, value, { expires: days })
  },
  get: function (name: string) {
    return Cookies.get(name)
  },
  hasConsent: function () {
    return Boolean(Cookies.get('CookieConsent'))
  },
  remove: function (name: string) {
    Cookies.remove(name)
  }
}

export const generateCookiePreferences = (domain: string) => [
  {
    id: 'necessary',
    accordion: [
      {
        header: domain,
        details: [
          {
            title: 'publicToken',
            description:
              'cookie.details.necessary.accordion.auth.publicToken.description',
            expiry:
              'cookie.details.necessary.accordion.auth.publicToken.expiry',
            type: 'Local Storage'
          },
          {
            title: 'token',
            description:
              'cookie.details.necessary.accordion.auth.token.description',
            expiry: 'cookie.details.necessary.accordion.auth.token.expiry',
            type: 'Local Storage'
          },
          {
            title: 'ORG_ID_LS_KEY',
            description:
              'cookie.details.necessary.accordion.auth.orgId.description',
            expiry: 'cookie.details.necessary.accordion.auth.orgId.expiry',
            type: 'Local Storage'
          },
          {
            title: 'amplify-signin-with-hostedUI',
            description:
              'cookie.details.necessary.accordion.auth.amplify.description',
            expiry: 'cookie.details.necessary.accordion.auth.amplify.expiry',
            type: 'Local Storage'
          },
          {
            title: 'CognitoIdentityServiceProvider.*',
            description:
              'cookie.details.necessary.accordion.cognito.description',
            expiry: 'cookie.details.necessary.accordion.cognito.expiry',
            type: 'Local Storage'
          },
          {
            title: 'selectedContractId',
            description:
              'cookie.details.necessary.accordion.session.contractId.description',
            expiry:
              'cookie.details.necessary.accordion.session.contractId.expiry',
            type: 'Local Storage'
          },
          {
            title: 'referrer',
            description:
              'cookie.details.necessary.accordion.session.referrer.description',
            expiry:
              'cookie.details.necessary.accordion.session.referrer.expiry',
            type: 'Local Storage'
          },
          {
            title: 'cookie.details.necessary.accordion.session.consent.header',
            description:
              'cookie.details.necessary.accordion.session.consent.description',
            expiry: 'cookie.details.necessary.accordion.session.consent.expiry',
            type: 'Local Storage'
          },
          {
            title: 'throttleAcrossVisits:*',
            description:
              'cookie.details.necessary.accordion.session.throttle.description',
            expiry:
              'cookie.details.necessary.accordion.session.throttle.expiry',
            type: 'Local Storage'
          },
          {
            title:
              'cookie.details.necessary.accordion.session.loginAsUser.header',
            description:
              'cookie.details.necessary.accordion.session.loginAsUser.description',
            expiry:
              'cookie.details.necessary.accordion.session.loginAsUser.expiry',
            type: 'HTTP'
          }
        ]
      }
    ]
  },
  {
    id: 'preferences',
    accordion: [
      {
        header: domain,
        details: [
          {
            title: 'language',
            description:
              'cookie.details.preferences.accordion.language.description',
            expiry: 'cookie.details.preferences.accordion.language.expiry',
            type: 'Local Storage'
          },
          {
            title: 'theme',
            description:
              'cookie.details.preferences.accordion.theme.description',
            expiry: 'cookie.details.preferences.accordion.theme.expiry',
            type: 'Local Storage'
          }
        ]
      }
    ]
  },
  {
    id: 'statistics',
    accordion: [
      {
        header: 'www.datadoghq-browser-agent.com',
        details: [
          {
            title: '_dd_s',
            description:
              'cookie.details.statistics.accordion.dd.dd_s.description',
            expiry: 'cookie.details.statistics.accordion.dd.dd_s.expiry',
            type: 'HTTP'
          }
        ]
      },
      {
        header: 'www.fullstory.com',
        details: [
          {
            title: '_fs_uid',
            description:
              'cookie.details.statistics.accordion.fs._fs_uid.description',
            expiry: 'cookie.details.statistics.accordion.fs._fs_uid.expiry',
            type: 'HTTP'
          },
          {
            title: '_fs_lua',
            description:
              'cookie.details.statistics.accordion.fs._fs_lua.description',
            expiry: 'cookie.details.statistics.accordion.fs._fs_lua.expiry',
            type: 'HTTP'
          },
          {
            title: 'fs_uid (Local Storage)',
            description:
              'cookie.details.statistics.accordion.fs.fs_uid_ls.description',
            expiry: 'cookie.details.statistics.accordion.fs.fs_uid_ls.expiry',
            type: 'Local Storage'
          },
          {
            title: '_fs_lua (Local Storage)',
            description:
              'cookie.details.statistics.accordion.fs._fs_lua_ls.description',
            expiry: 'cookie.details.statistics.accordion.fs._fs_lua_ls.expiry',
            type: 'Local Storage'
          },
          {
            title: '__anon_id',
            description:
              'cookie.details.statistics.accordion.fs.__anon_id.description',
            expiry: 'cookie.details.statistics.accordion.fs.__anon_id.expiry',
            type: 'Local Storage'
          }
        ]
      },
      {
        header: 'www.google-analytics.com',
        details: [
          {
            title: '_ga',
            description:
              'cookie.details.statistics.accordion.ga._ga.description',
            expiry: 'cookie.details.statistics.accordion.ga._ga.expiry',
            type: 'HTTP'
          },
          {
            title: '_gid',
            description:
              'cookie.details.statistics.accordion.ga._gid.description',
            expiry: 'cookie.details.statistics.accordion.ga._gid.expiry',
            type: 'HTTP'
          },
          {
            title: '_gat',
            description:
              'cookie.details.statistics.accordion.ga._gat.description',
            expiry: 'cookie.details.statistics.accordion.ga._gat.expiry',
            type: 'HTTP'
          },
          {
            title: 'gac<property-id>',
            description:
              'cookie.details.statistics.accordion.ga.gac.description',
            expiry: 'cookie.details.statistics.accordion.ga.gac.expiry',
            type: 'HTTP'
          },
          {
            title: '_utm* (e.g., _utma, _utmb, _utmc, _utmt, _utmz)',
            description:
              'cookie.details.statistics.accordion.ga._utm.description',
            expiry: 'cookie.details.statistics.accordion.ga._utm.expiry',
            type: 'HTTP'
          },
          {
            title: '_gaexp',
            description:
              'cookie.details.statistics.accordion.ga._gaexp.description',
            expiry: 'cookie.details.statistics.accordion.ga._gaexp.expiry',
            type: 'HTTP'
          }
        ]
      }
    ]
  }
]

export const tabs = [
  {
    id: 'consent',
    title: 'Consent',
    value: TAB.Consent
  },
  {
    id: 'details',
    title: 'Details',
    value: TAB.Details
  },
  {
    id: 'about',
    title: 'About',
    value: TAB.About
  }
]

export type ActiveTab = 'consent' | 'details' | 'about'

export const googleAnalyticsHeader = 'www.google-analytics.com'
